import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import DiagonalBottom from '../../diagonalbottom';
import DiagonalTop from '../../diagonaltop';
import {
  ChallengeStyled,
  Inner,
  HeadLine,
  ChallengeSolution,
  ChallengeBlock,
  SolutionBlock,
} from './style';

interface Props {
  headLineText: string;
  challengeText: string;
  solutionText: string;
}

const Challenge: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <ChallengeStyled>
      <DiagonalTop />
      <Inner>
        <div className="container">
          <HeadLine dangerouslySetInnerHTML={{ __html: props.headLineText }} />
          <ChallengeSolution>
            <ChallengeBlock>
              <h3>{t('UseCaseChallengeChallengeTitle')}</h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: props.challengeText,
                }}
              />
            </ChallengeBlock>
            <SolutionBlock>
              <h3>{t('UseCaseChallengeSolutionTitle')}</h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: props.solutionText,
                }}
              />
            </SolutionBlock>
          </ChallengeSolution>
        </div>
      </Inner>
      <DiagonalBottom />
    </ChallengeStyled>
  );
};

export default Challenge;
